import { WriteHandler } from './types';
import { createPatientHandler } from './patient';
import {
  createEncounterHandler,
  addConditionHandler,
  addAllergyHandler,
  addFamilyHistoryHandler,
  addProcedureHandler,
  addClinicalImpressionHandler,
  addMedicationStatementHandler,
} from './consultation';
import { createAppointmentHandler, createClinicAppointmentHandler } from './appointment';

export type { WriteHandler };

/**
 * Maps a queued write's `handler` name to the function that replays it.
 * Each handler module exports plain named functions (no self-registration
 * side effects) so there's no circular import back into this file --
 * index.ts is the only place that assembles the registry.
 */
export const handlerRegistry: Record<string, WriteHandler> = {
  'create-patient': createPatientHandler,
  'create-encounter': createEncounterHandler,
  'add-condition': addConditionHandler,
  'add-allergy': addAllergyHandler,
  'add-family-history': addFamilyHistoryHandler,
  'add-procedure': addProcedureHandler,
  'add-clinical-impression': addClinicalImpressionHandler,
  'add-medication-statement': addMedicationStatementHandler,
  'create-appointment': createAppointmentHandler,
  'create-clinic-appointment': createClinicAppointmentHandler,
};
